module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "box center-width"
  }, [(!_vm.userInfo || !_vm.userInfo.userId) ? _c('span', {
    staticClass: "mr40"
  }, [_c('a', {
    attrs: {
      "href": "login.html"
    }
  }, [_vm._v("登录/注册")])]) : _c('span', {
    staticClass: "mr40"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('el-dropdown', [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.userInfo.partFullName)), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.loginOut()
      }
    }
  }, [_vm._v("退出登录")])])], 1)], 1)], 1)]), _vm._v(" "), (_vm.userInfo && _vm.userInfo.userId) ? _c('span', {
    staticClass: "mr40"
  }, [_c('a', {
    attrs: {
      "href": "userCenter.html",
      "target": "_blank"
    }
  }, [_vm._v("个人中心")])]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', [_vm._v("客服热线")]), _vm._v(" "), _c('span', {
    staticClass: "phone mr40"
  }, [_vm._v("021-31353514")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "index.html"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icons/Telephone_icon.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-4406575b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/header.vue
// module id = 458
// module chunks = 0 1 4 5 6 7 8 9 10 11